module.exports = __webpack_public_path__ + "static/media/PatronajeIcon.1722c990.svg";